"use strict";
/**
 * Billing contracts (Stripe).
 *
 * INSTALL-LEVEL: this app is single-org ("Tenant = site"; Brand Workspaces are the multi-tenancy),
 * so ONE Stripe customer + subscription covers the whole install and seats count every User. The
 * model is ported from Flying Penguin, where the equivalent is per-tenant because that app really
 * is multi-tenant.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIN_JUSTIFICATION_LENGTH = exports.SUBSCRIPTION_STATUS_LABEL = exports.LIVE_SUBSCRIPTION_STATUSES = exports.STRIPE_MIN_TRIAL_LEAD_MS = exports.BILLING_APP_METADATA_KEY = exports.BILLING_APP_TAG = void 0;
/**
 * Stamped on the Stripe customers and subscriptions this app creates.
 *
 * Smorgas Social has its OWN Stripe account (separate from the other Smorgas apps), so this is
 * NOT an ownership mechanism — event isolation comes free with the account, and the webhook's real
 * guard is that an event must match this install's stored subscription/customer id. The tag is
 * kept because it costs nothing and makes objects obvious in the dashboard and in exports.
 */
exports.BILLING_APP_TAG = 'marketing-genie';
exports.BILLING_APP_METADATA_KEY = 'app';
/** Statuses that mean a live, billable subscription — the set a plan change must repoint in place. */
/**
 * Stripe refuses a `trial_end` nearer than this: "The trial_end date has to be at least 2 days in
 * the future." A plan start date is implemented as `trial_end`, so this is the minimum lead time
 * for one - enforced where the date is SET and again where a checkout is built, because a date
 * stored before the rule existed is still in the database.
 */
exports.STRIPE_MIN_TRIAL_LEAD_MS = 48 * 60 * 60 * 1000;
exports.LIVE_SUBSCRIPTION_STATUSES = [
    'ACTIVE',
    'TRIALING',
    'PAST_DUE',
];
/** Human label for a status badge. */
exports.SUBSCRIPTION_STATUS_LABEL = {
    INCOMPLETE: 'Incomplete',
    TRIALING: 'Trialing',
    ACTIVE: 'Active',
    PAST_DUE: 'Past due',
    UNPAID: 'Unpaid',
    CANCELED: 'Canceled',
    PAUSED: 'Paused',
};
/** The shortest justification the server will accept for a repeat charge. */
exports.MIN_JUSTIFICATION_LENGTH = 10;
//# sourceMappingURL=billing.js.map